import { render, staticRenderFns } from "./PromoterSelect.vue?vue&type=template&id=9ca72c88"
import script from "./PromoterSelect.vue?vue&type=script&lang=js"
export * from "./PromoterSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports